/* eslint-disable @typescript-eslint/no-explicit-any */
import { IConfig } from '@cian/config/shared';

interface ITop30Pages {
  host: string;
  defaultPath: string;
  paths: IPathMatch[];
}

interface IPathMatch {
  regionId: number;
  path: string;
}

const isValueOfType = (value: any, type: 'string' | 'number' | 'object') => typeof value === type && value !== null;

const validateTop30Pages = (top30Pages: any) => {
  if (!isValueOfType(top30Pages, 'object')) {
    return false;
  }

  if (!isValueOfType(top30Pages.host, 'string') || !top30Pages.host) {
    return false;
  }

  if (!isValueOfType(top30Pages.defaultPath, 'string')) {
    return false;
  }

  if (!top30Pages.paths || !Array.isArray(top30Pages.paths)) {
    return false;
  }

  if (
    top30Pages.paths.some((path: any) => {
      return !isValueOfType(path.regionId, 'number') || !isValueOfType(path.path, 'string');
    })
  ) {
    return false;
  }

  return true;
};

const getCorrectValueFromConfig = (config: IConfig) => {
  const value = config.get<ITop30Pages>('top30SpecialistsRegionUrls');

  return validateTop30Pages(value) ? value : null;
};

const createUrl = (id: number, configValue: ITop30Pages) => {
  const pathMatch = configValue.paths.find(({ regionId }) => regionId === id);
  const path = pathMatch ? pathMatch.path : configValue.defaultPath;

  return new URL(path, configValue.host).href;
};

export const getUrlById = (id: number, config: IConfig) => {
  const configValue = getCorrectValueFromConfig(config);

  if (!configValue) {
    return null;
  }

  return createUrl(id, configValue);
};
